import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'list-banklinks',
	templateUrl: './list-banklinks.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ListBanklinksComponent implements OnInit, OnDestroy {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() isRequired: any | undefined;
	@Input() booking: any | undefined;
	@Input() bookingOffer: any | undefined;
	@Input() banklinks: any | undefined;
	@Output() banklinksChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() isLoading: any | undefined;
	@Output() isLoadingChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() loadError: any | undefined;
	@Output() loadErrorChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() name: any | undefined;
	@Input() reloadNeeded: any;
	@Output() reloadNeededChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() activeBanklink: any;
	@Output() activeBanklinkChange: EventEmitter<any> = new EventEmitter<any>();
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		if (typeof this.vm.name === 'undefined') this.vm.name = 'banklink';
		this.vm.uid = 'lb-' + Date.now();
		this.handleBanklinksInit(false);
		
		this.vm.getBankLogo = this.getBankLogo;
		this.vm.getBankLogoStyles = this.getBankLogoStyles;
			
		var currentReloadNeeded = this.vm.reloadNeeded;
		this.watcher = this.angularHelperService.createInterval(() => {
			if (this.vm.reloadNeeded !== currentReloadNeeded) {
				if (this.vm.reloadNeeded) {
					this.vm.reloadNeeded = false;
					currentReloadNeeded = this.vm.reloadNeeded;
					this.handleBanklinksInit(true);
					this.reloadNeededChange.emit(this.vm.reloadNeeded);
				}
			}
		}, 300);
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	getBankLogo(banklink) {
		return 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/banks/' + banklink.bankName.toLowerCase() + '.svg';
	}
	
	getBankLogoStyles(banklink) {
		var name: any = banklink.bankName.toLowerCase();
		var styles: any = {
			swed: {
				height: '23px',
			},
			lhv: {
				height: '21px',
				marginTop: '2px',
			},
			coop: {
				height: '20px',
				marginTop: '1px',
			},
			luminor: {
				height: '19px',
				marginTop: '-1px',
			}
		};
		if (!name || !styles[name]) return;
		
		return styles[name];
	}
	
	handleBanklinksInit(reload) {
		if ((!this.vm.booking && !this.vm.bookingOffer) || (this.vm.booking && !this.vm.booking.id) || (this.vm.bookingOffer && !this.vm.bookingOffer.id) || (this.vm.banklinks && !reload)) return;
		var params = this.vm.bookingOffer ? { bookingOfferId: this.vm.bookingOffer.id } : { bookingId: this.vm.booking.id };
		var successCallback = (banklinks) => {
			this.vm.banklinks = banklinks;
			this.vm.isLoading = false;
			this.vm.loadError = false;
			this.banklinksChange.emit(this.vm.banklinks);
			this.isLoadingChange.emit(this.vm.isLoading);
			this.loadErrorChange.emit(this.vm.loadError);
		};
		var errorCallback = (error) => {
			console.error(error);
			this.vm.isLoading = false;
			this.vm.loadError = true;
			this.isLoadingChange.emit(this.vm.isLoading);
			this.loadErrorChange.emit(this.vm.loadError);
		};
		this.vm.isLoading = true;
		this.vm.loadError = false;
		this.isLoadingChange.emit(this.vm.isLoading);
		this.loadErrorChange.emit(this.vm.loadError);
		if (this.vm.bookingOffer) {
			this.serviceRestServices.getBookingOfferSupportedBanklinks(params, successCallback, errorCallback);
		} else if (this.vm.booking.service) {
			this.serviceRestServices.getSupportedBanklinks(params, successCallback, errorCallback);
		} else {
			this.serviceRestServices.getInstantBookingSupportedBanklinks(params, successCallback, errorCallback);
		}
	}
	
	banklinkSelected() {
		this.activeBanklinkChange.emit(this.vm.activeBanklink);
	}
	
}
